let returnArrayOfNames : any;
export default returnArrayOfNames = (ArrayOfObjects: any) => {
    let arrayOfObjectNames: any = [];
    const objectNames: any = [];
    ArrayOfObjects.forEach((valueOfObject: any) => {
      objectNames.push(valueOfObject.name?valueOfObject.name:valueOfObject.weekNo);
    });
    return objectNames;
  }